const AWSconfig = {
  accessKeyId: 'AKIAYND3KM66GRG3WMVL',
  secretAccessKey: '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',
  region: 'us-east-1',
  source: 'noreply@ilocalbox.com',
  bucket: 'rpx-dev-ext-images-qr'
};
export default AWSconfig;
